class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVariantSelects();
  }

  setupVariantSelects() {
    const selects = this.querySelectorAll('select[data-option-name]');
    
    selects.forEach(select => {
      select.addEventListener('change', () => {
        this.clickMainVariantSelector(select);
      });
    });
  }

  clickMainVariantSelector(cartBarSelect) {
    const optionValue = cartBarSelect.value;
    
    const mainProductForm = document.querySelector('.product__form__outer');
    if (!mainProductForm) return;

    const variantInputs = mainProductForm.querySelectorAll('input[name^="options"]');
    const mainInput = Array.from(variantInputs).find(input => input.value === optionValue);
    
    if (mainInput) {
      mainInput.click();
    }
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}